// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createTableEntryFee_entryTitle__3rmir {\n  display: flex;\n  justify-content: space-between;\n}", ""]);
// Exports
exports.locals = {
	"entryTitle": "createTableEntryFee_entryTitle__3rmir"
};
module.exports = exports;
